import { App } from "app";
import { createRoot } from "react-dom/client";

import { analytics } from "./common/analytics";
import { AnalyticsEvents } from "./common/analytics/events";
// catch all unhandled rejections
window.addEventListener("unhandledrejection", function (event) {
  event = event || {};
  console.error(
    "Unhandled rejection (promise: ",
    event.promise,
    ", reason: ",
    event.reason,
    ")."
  );
});

// Register global properties and track session start
analytics.register({ gitsha: import.meta.env.VITE_GITSHA ?? "" });
analytics.track(AnalyticsEvents.SESSION_STARTED);

const container = document.getElementById("root");
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
